import { createContext, useContext } from "react";
const DisableRegisterElement = createContext(false);
function useDisableRegisterElement() {
  return useContext(DisableRegisterElement);
}
export {
  DisableRegisterElement,
  useDisableRegisterElement
};
//# sourceMappingURL=use-disable-register-element.js.map